var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLnerLogoWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 185,
    height: 72,
    viewBox: "0 0 185 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M97.1331 12.6914H133.054V22.0174H107.566V31.6596H129.972V40.9856H107.566V50.9834H133.37V60.3094H97.1331V12.6914Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 12.6914V60.3094H32.1668V55.3303H5.37431V12.6914H0Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M164.826 36.9944C171.978 36.9944 177.076 33.3193 177.076 27.1941V27.0756C177.076 21.2271 172.571 17.7101 164.905 17.7101H150.204V37.0339H164.826V36.9944ZM144.83 12.6914H165.3C171.148 12.6914 175.851 14.4697 178.815 17.4334C181.107 19.765 182.49 23.0844 182.49 26.799V26.9175C182.49 34.8209 177.036 39.4444 169.568 40.788L184.189 60.2304H177.59L163.798 41.7364H163.68H150.204V60.2304H144.83V12.6914Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M43.4299 60.303H53.7834V30.0329L85.7131 72V12.685H75.3992V42.0066L43.4299 0V60.303Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLnerLogoWhite);
export default __webpack_public_path__ + "static/media/lner_logo_white.f2d63bd75979c320347eb7b776c4097e.svg";
export { ForwardRef as ReactComponent };